module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image21.eb588570.jpg";